// extracted by mini-css-extract-plugin
export default {"sponsoredGrid":"school-list_sponsoredGrid__UvTWt","mainList":"school-list_mainList__FQVP1","skeletonCard":"school-list_skeletonCard__BuIoE","notFound":"school-list_notFound__7RJ8r"};